<template>
    <v-container class="px-0 pb-5">
        <v-form ref="form" :loading="loading">
            <v-row >
                  <!-- Non mostrare la lista dei veicoli dati non sempre corretti -->
                <v-col cols="12" class="d-none">

                    <v-row align="center">
                       
                        <v-col cols="6" md="4" class="mx-auto" v-for="car in list " :key="car.id">
                            <v-card  @click="setSingleCar(car)" :class="(search.carId == car.id) ? 'border' : ''">
                                <v-img
                                    v-if="car.images.list.length"
                                    width="380px"
                                    :src="car.images.prefix + car.images.list[0].idimg +'.jpg'"
                                    lazy
                                ></v-img> 
                                <v-img
                                    v-else
                                    width="380px"
                                    :src="'https://fakeimg.pl/800x480?font=bebas&font_size=41&text='+car.displayName"
                                    lazy
                                >
                                <v-chip size="small" class="float-end">car id: {{ car.id }}</v-chip>
                                </v-img> 
                                <v-card-text>
                                    <v-icon size="small" class="me-2" v-if="(search.carId == car.id)">mdi-check</v-icon>
                                    {{ car.brand }}
                                    {{ car.model }}
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>

                </v-col>

                <v-col cols="12" md="6" >
                    <placeFieldVue
                        :preValue="search.start"
                        @update="setLocationStart"
                        label="attributes.location_start.label"
                    ></placeFieldVue>
                </v-col>
                <v-col cols="12" md="6" >
                    <placeFieldVue
                        :preValue="search.end"
                        @update="setLocationEnd"
                        label="attributes.location_end.label"
                    ></placeFieldVue>
                </v-col>
                <v-col cols="12" md="12" >
                    <range-date-picker 
                        @update="setDates"
                        :preValue="search"
                        :label="t('attributes.date_range.label')">
                    </range-date-picker>
                </v-col>
                <v-col cols="10" class="mx-auto">
                    <v-btn 
                        :loading="loading" 
                        block 
                        @click="submit" 
                        class="rounded-pill mx-auto"  
                        color="primary">
                        {{ button }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>
    </v-container>
</template>


<script setup>
    
    import placeFieldVue from '@/components/AdvancedFields/placeField.vue'
    import rangeDatePicker from '@/components/AdvancedFields/rangeDatePicker.vue'

    import { useLocale } from 'vuetify'
    const { t } = useLocale()
</script>

<script>
import {mapGetters} from "vuex";
export default {
    props:{
        list:{
            type: Array,
            required: true,
        },
        button:{
            type: String,
            required: true,
        }
    },
    computed: {
        ...mapGetters({
            loading: 'loading/loading',
            success: 'driveSearch/success',
            message: 'driveSearch/message',
            errors: 'driveSearch/errors',
            search: 'driveSearch/search',
        }),
    },
    data: () => ({
        form: {
            car: null,
            id: null,
            start: null,
            end: null,
        },
    }),
    mounted(){
        this.setModelTypeBrand(this.list[0])
    },
    methods:{
        setDates(val){
            this.search.start.date = val.startDate
            this.search.end.date = val.endDate
        },
        setLocationStart(val){
            this.search.start = {... this.search.start, ...val}
        },
        setLocationEnd(val){
            this.search.end = {...this.search.end, ...val}
        },
        updateSearch(data){
            this.search = data
        },
        async validate () {
            const { valid } = await this.$refs.form.validate()
            return valid;
        },
        setSingleCar(item){
            this.search.carId = item.id
            this.search.filter.type  =[ item.typeId ]
            this.search.filter.brand =[ item.brandId ]
            this.search.filter.model =[ item.modelId ]
        },
        setModelTypeBrand(item){
            this.search.filter.type  =[ item.typeId ]
            this.search.filter.brand =[ item.brandId ]
            this.search.filter.model =[ item.modelId ]
        },
       
        reset () {
            this.$refs.form.reset()
        },
        resetValidation () {
            this.$refs.form.resetValidation()
        },
        async submit(){
            this.resetValidation();
            if( await this.validate() ){

                this.$gtm.trackEvent({
                    event: 'checkAvailability',
                    data: this.search,
                })

                this.$store.dispatch('driveSearch/search', this.search)
                
                this.$router.push({name:'search-result'})
                
            }

        }
    }
}
</script>